module.exports = __webpack_public_path__ + "static/media/driver-step-icon.67af60ba.svg";